import { BaseDataService } from './BaseDataService';
import { UserScoreCardGroupCharacteristic } from '../../models';
import { NotificationService } from '../../services';

export class UserScoreCardGroupCharacteristicDataService extends BaseDataService<UserScoreCardGroupCharacteristic> {
    constructor(notificationService: NotificationService) {
        super('User Score Card Group Characteristic', 'User Score Card Group Characteristics', notificationService);
    }

    public getAllByUser(userId: number, scoreCardId: number): Promise<any> {
        const endpoint = `${this.endpointRoot}/${scoreCardId}/byUser/${userId}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving characterisics.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public save(userScoreCardGroupCharacteristic: UserScoreCardGroupCharacteristic): Promise<any> {
        const endpoint = `${this.endpointRoot}`;
        const init = this.buildRequestInit('PUT', userScoreCardGroupCharacteristic);

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving characterisics.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public clear(userId: number, scoreCardId: number): Promise<any> {
        const endpoint = `${this.endpointRoot}/clear/${userId}/${scoreCardId}`;
        const init = this.buildRequestInit('POST');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving characterisics.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/api/UserScoreCardGroupCharacteristicDataService.tsx